import React from "react";
import useStore, { audio, playAudio } from "../store";
import strings from "../lang/Localiz";
import SuperPrizeList from "./SuperPrizeList";
import CommonPrizeList from "./CommonPrizeList";

function ModalSuperPrize() {
  const sound = useStore((state) => state.sound);

  const cell = useStore((state) => state.i);
  const checkPoint = [1, 18, 35, 52, 69, 86, 103];
  const circle = checkPoint.lastIndexOf(cell);
  const closeinfoModalStation = useStore(
    (state) => state.closeinfoModalStation
  );
  const modalSuperPrize = useStore((state) => state.modalSuperPrize);

  let give_prize = useStore((state) => state.give_prize);

  const lang = strings.getLanguage();


  React.useEffect(() => {
    if (modalSuperPrize && sound) playAudio(audio.checkpoint);
  }, [modalSuperPrize, sound])

  if (modalSuperPrize) {
    return (
      <div className={"hud-modal"}>
          <div className="close-wrapper" onClick={closeinfoModalStation}></div>
          <div className={"hud-modal-content-gift"}>
          <div className={"hud-title mini-title"}>{strings.success}</div>
          <div className={"hud-modal-content-block"}>
            <div className={"found-txt"}>
              {cell === 103 ? strings.checkpointHint.last : strings.checkpointHint.title}
              <br />
              {strings.checkpointHint.description}
            </div>
            <div className={"found-gift"}>
              <CommonPrizeList
                lang={lang}
                showCommonKey={give_prize[circle].common_key > 0}
                showRareKey={give_prize[circle].rare_key > 0}
                showEpicKey={give_prize[circle].epic_key > 0}
                showGrenade={give_prize[circle].grenade > 0}
                showSnowball={give_prize[circle].snowball > 0}
                showKing={give_prize[circle].king > 0}
                showFirework={give_prize[circle].firework > 0}
                showCrystals={give_prize[circle].crystal > 0}
                showDamage={give_prize[circle].damage > 0}
                showBoost={give_prize[circle].boost > 0}
                showRepair={give_prize[circle].repair > 0}
                showProtection={give_prize[circle].protection > 0}
                common_key={give_prize[circle].common_key}
                rare_key={give_prize[circle].rare_key}
                epic_key={give_prize[circle].epic_key}
                grenade={give_prize[circle].grenade}
                snowball={give_prize[circle].snowball}
                king={give_prize[circle].king}
                firework={give_prize[circle].firework}
                crystal={give_prize[circle].crystal}
                damage={give_prize[circle].damage}
                boost={give_prize[circle].boost}
                repair={give_prize[circle].repair}
                protection={give_prize[circle].protection}
              />
              <SuperPrizeList
                point_one={give_prize[circle].point_one > 0}
                point_two={give_prize[circle].point_two > 0}
                point_three={give_prize[circle].point_three > 0}
                point_four={give_prize[circle].point_four > 0}
                point_five={give_prize[circle].point_five > 0}
                point_six={give_prize[circle].point_six > 0}
                point_seven={give_prize[circle].point_seven > 0}
              />
            </div>

            <div onClick={closeinfoModalStation} className={"approve-btn"}>
              {strings.approve}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default ModalSuperPrize;
